
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {moduleResourceApi, moduleApi, menuApi} from "@/api/organization";

    @Component({name:'Sys_Menu'})
    export default class Home extends Vue {
        timeout: any
        loading = false
        menuList = [] // 菜单列表
        resList = [] // 资源列表
        moduleList = [] //模块列表
        options = [] //搜索下拉框
        menuSaving = false
        menuForm = this.resetMenuFrom()
        formRules = {
            name: [{required: true, message: '请输入菜单名称', trigger: 'blur'}],
            // resourceId: [{required: true, message: '请选择权限名称'}],
        }
        menuItem: any = null
        menuDialog = {
            visible: false,
        }
        moduleId = ''

        //生命周期销毁：
        destroyed() {
            // 清除定时器
            clearTimeout(this.timeout);
        }

        isDisabledMove(row: any, moveType: string) {
            if (moveType === 'up') {
                return row.upDisable;
            } else if (moveType === 'down') {
                return row.downDisable;
            }
        }

        created() {
            this.listModule();
        }

        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }

        resetMenuFrom() {
            return {
                id: 0,
                name: '',
                mrDisplayName: '', //权限名称
                url: '',
                icon: '',
                orderIndex: 0,
                visiable: false,
                target: '_self',
                parentId: null,
                resourceId: null,
                moduleId: '',
                description: '',
            }
        }

        addMenu() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    this.menuSaving = true;
                    const menuForm = this.cloneObjectFn(this.menuForm);
                    if (menuForm.id) {
                        menuApi.update(menuForm).then(data => {
                            if (data.data.result === 0) {
                                this.$message.success("编辑成功")
                                this.menuDialog.visible = false;
                                this.menuSaving = false;
                                this.menuItem = null;
                                this.menuForm = this.resetMenuFrom();
                                this.getItemTree()
                            }
                        })
                    } else {
                        menuForm.parentId = this.menuItem !== null ? this.menuItem.id : 0;
                        menuApi.add(menuForm).then(data => {
                            if (data.data.result === 0) {
                                this.$message.success("添加成功")
                                this.menuDialog.visible = false;
                                this.menuSaving = false;
                                this.menuItem = null;
                                this.menuForm = this.resetMenuFrom();
                                this.getItemTree()
                            }
                        });
                    }

                }
            })
        }

        changeModule() {
            this.getItemTree();
        }

        editIndexItemBtn(item: any) {
            this.menuItem = item;
            this.menuDialog.visible = true;
            Object.assign(this.menuForm, item)
            this.listResource(item.moduleId);
        }

        toAddResource() {
            const routeData = this.$router.resolve("/sys/resource/" + this.menuForm.moduleId);
            window.open(routeData.href, '_blank');
        }

        moveIndexItem(row: any, moveType: string) {
            const id = row.id;
            let orderId = 0;
            if (moveType === 'up') {
                orderId = row.upOrderId;
            } else if (moveType === 'down') {
                orderId = row.downOrderId;
            }
            menuApi.move({id: id, orderId: orderId}).then((data) => {
                if (data.data.result === 0) {
                    this.$message.success("移动成功")
                    this.getItemTree();
                }
            });
        }

        addMenuBtn(item: any) {
            this.menuDialog.visible = true;
            this.menuItem = item;
            let moduleId: any = '';
            if (item == null) {
                moduleId = this.moduleId;
            } else {
                moduleId = item.moduleId;
            }
            this.menuForm.moduleId = moduleId;
            this.listResource(moduleId);
        }

        closeMenuDialog() {
            this.menuItem = null;
            this.menuDialog = {visible: false}
            this.menuForm = this.resetMenuFrom();
        }

        listModule() {
            moduleApi.list().then(data => {
                if (data.data.result === 0) {
                    const moduleList: any = [...data.data.data];
                    this.moduleList = moduleList;
                    if(moduleList.length > 0){
                        this.moduleId = moduleList[0].id
                        this.getItemTree();
                    }
                }
            });
        }

        deleteIndexItem(row: any) {
            this.$confirm('确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                menuApi.delete({id: row.id}).then((data) => {
                    if (data.data.result === 0) {
                        this.$message.success("删除成功");
                        this.getItemTree();
                    }
                });
            }).catch(() => {
                console.log("取消")
            });
        }

        getItemTree() {
            menuApi.tree({moduleId: this.moduleId == '0' ? '' : this.moduleId}).then(data => {
                if (data.data.result === 0) {
                    const menuList = data.data.data;
                    this.addItemNumber(menuList);
                    this.menuList = menuList;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            });
        }

        addItemNumber(menuList: any) {
            let num = 0;
            menuList.forEach((menu: any) => {
                menu.upDisable = true;
                menu.downDisable = true;
                if (num != 0) {
                    menu.upOrderId = menuList[num - 1].id;
                    menu.upDisable = false;
                }
                if (num != (menuList.length - 1)) {
                    menu.downOrderId = menuList[num + 1].id;
                    menu.downDisable = false;
                }
                num++;
                if (menu.children && menu.children.length > 0) {
                    this.addItemNumber(menu.children);
                }
            });
        }

        remoteMethod(queryString: string) {
            if (queryString !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    moduleResourceApi.listByModule(Number(this.menuForm.moduleId)).then((data) => {
                        if (data.data.result === 0) {
                            const resList: any = data.data.data;
                            this.resList = queryString ? resList.filter(this.createStateFilter(queryString)) : resList;
                        } else {
                            this.resList = [];
                        }
                    });
                }, 200);
            } else {
                this.resList = [];
            }
        }

        listResource(moduleId: number) {
            moduleResourceApi.listByModule(moduleId).then((data) => {
                if (data.data.result === 0) {
                    this.resList = data.data.data;
                } else {
                    this.resList = [];
                }
            });
        }

        createStateFilter(queryString: string) {
            return (item: any) => {
                if (item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1 || item.displayName.toLowerCase().indexOf(queryString.toLowerCase()) > -1) {
                    return item;
                }
            };
        }

        // handleSelect(item: any){
        //     this.menuForm.resourceId = item.id;
        //     this.menuForm.mrDisplayName = item.value;
        // }
    }
